// @ts-nocheck
export { Layout as Area } from './Layout'
